import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-muted">
                <div className="flex items-center gap-3 text-primary">
                    <div className="h-5 w-5 rounded-full border-2 border-primary border-t-transparent animate-spin" />
                    <span className="font-heading font-semibold">A verificar sessão...</span>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/admin/login" replace state={{ from: location }} />;
    }

    if (user.role !== "admin") {
        return <Navigate to="/conta" replace />;
    }

    return children;
}
